import CodeModel                      from '@/models/services/code/CodeModel';
import CodePropertyModel              from '@/models/services/code/CodePropertyModel';
import CodeServiceModel               from '@/models/CodeServiceModel';
import { Code_CodePropertyReference } from '@/models/services/code/CodePropertyModel';
import doc                            from '@widesk-core/decorators/doc';
import model                          from '@widesk-core/decorators/model';

@model.urnResource('code_property_value')
@doc.path('/code_property_values/{?id}')
export default class CodePropertyValueModel extends CodeServiceModel {
	private declare _tsFilters: {
		'code': id;
		'codeProperty': id;
		'codeProperty.reference': Code_CodePropertyReference;
		'createdAt[after]': string | Date | Dayjs;
		'createdAt[before]': string | Date | Dayjs;
		'createdAt[strictly_after]': string | Date | Dayjs;
		'createdAt[strictly_before]': string | Date | Dayjs;
		'updatedAt[after]': string | Date | Dayjs;
		'updatedAt[before]': string | Date | Dayjs;
		'updatedAt[strictly_after]': string | Date | Dayjs;
		'updatedAt[strictly_before]': string | Date | Dayjs;
	};

	private declare _tsSorts: {
		'createdAt': string;
		'id': string;
		'updatedAt': string;
	};

	@doc.model(CodeModel) declare code: CodeModel;
	@doc.model(CodePropertyModel) declare codeProperty: CodePropertyModel;
	@doc.string declare value: string;
}